export class Video {
    init() {
        var self = this;
        $('.video-player').hover(function (e) {
            e.preventDefault();
            var $this = $(this);
            self.play($this);
        }, function (e) {
            e.preventDefault();
            var $this = $(this);
            self.stop($this)
        });
    }

    play(video) {
        var videoType = video.data('type');
        if (videoType == 'youtube') {
            video = $(video)[0].contentWindow;
            video.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (videoType == 'video') {
            video = video.get(0);
            video.play();
        }

    }

    stop(video) {
        var videoType = video.data('type');
        if (videoType == 'youtube') {
            video = $(video)[0].contentWindow;
            video.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (videoType == 'video') {
            video = video.get(0);
            video.pause(); 
        }
    }
}